<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="center">TO MY WRITING PARTNERS,<br/>CODY AND LAURIE,<br/>AND IN MEMORIAM<br/>KEN CMIEL</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780865477377_epub_ded_r1.vue?ad4ffd1c